import { render, staticRenderFns } from "./PaymentRefound.vue?vue&type=template&id=3f0f3274"
import script from "./PaymentRefound.vue?vue&type=script&lang=js"
export * from "./PaymentRefound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports